import React, { useContext, useState } from "react";
import "font-awesome/css/font-awesome.min.css";
import { Button, Modal, Space, Typography, Tooltip } from "antd";
import Tables from "./Tabels";
import GeoForm from "./GeoForm";
import { context } from "../../context/context";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const GeoUnitTable = ({ ostan, shahrestan, shahr }) => {
    const {
        isModalOpen,
        setIsModalOpen,
        setOstanIcon,
        setOstanName,
        setOstanColor,
        setOstanId,
        setIsEditShow,
        setShahrestanName,
        setShahrestanIcon,
        setShahrestanColor,
        setShahrestanId,
        isEditShow,
        setCityName,
        setCityColor,
        setCityIcon,
        setCityTag,
        parentOstanId,
        countryId,
        provinces,
        setOstan,
        setShahrestan,
        setShahr,
        setCountry,
        setFileList,
    } = useContext(context);
    const showModal = () => {
        setFileList([]);
        setIsModalOpen(true);
        if (ostan) {
            setOstanName("");
            setOstanIcon("");
            setOstanColor("#FFFFFF");
            setOstanId("");
        } else if (shahrestan) {
            setShahrestanName("");
            setShahrestanIcon("");
            setShahrestanColor("#FFFFFF");
            setShahrestanId("");
        } else if (shahr) {
            setCityName("");
            setCityIcon("");
            setCityColor("#FFFFFF");
            setCityTag([]);
        }

        setIsEditShow(false);
    };

    const handleCancel = () => {
        setIsModalOpen(false);
        setFileList([]);
    };
    const handleTableTitle = () => {
        const parentProvince = provinces?.find((p) => p._id === parentOstanId);
        const parentCountry = countryId
            ? parentProvince.county.find((c) => c._id === countryId)
            : null;

        const title =
            shahrestan && parentProvince ? (
                <Tooltip title={`نمایش استان ها`}>
                    <Typography.Link
                        onClick={() => {
                            setOstan(true);
                            setShahrestan(false);
                        }}
                    >
                        {parentProvince.province}
                    </Typography.Link>
                </Tooltip>
            ) : shahr && countryId && parentProvince ? (
                <div>
                    <Tooltip title={`نمایش استان ها`}>
                        <Typography.Link
                            onClick={() => {
                                setOstan(true);
                                setShahrestan(false);
                                setShahr(false);
                            }}
                        >{`${parentProvince.province} / `}</Typography.Link>
                    </Tooltip>
                    <Tooltip
                        title={`نمایش شهرستان های ${parentProvince.province}`}
                    >
                        <Typography.Link
                            onClick={() => {
                                setShahrestan(true);
                                setShahr(false);
                                setCountry(
                                    provinces.find(
                                        (p) => p._id === parentProvince._id
                                    ).county
                                );
                            }}
                        >
                            {parentCountry.name}
                        </Typography.Link>
                    </Tooltip>
                </div>
            ) : (
                <span></span>
            );
        return title;
    };
    const btnTitle = ostan
        ? "ثبت استان جدید"
        : shahrestan
        ? "ثبت شهرستان جدید"
        : "ثبت شهر یا روستا جدید";

    const btnEditTitle = ostan
        ? "ویرایش استان "
        : shahrestan
        ? "ویرایش شهرستان "
        : "ویرایش شهر یا روستا ";

    return (
        <div className="geoTable">
            <Space
                direction="horizontal"
                style={{ width: "100%", justifyContent: "space-between" }}
                align="end"
            >
                {handleTableTitle()}
                <Button onClick={showModal} type="primary" ali>
                    {btnTitle}
                </Button>
            </Space>
            <Tables />
            <Modal
                title={!isEditShow ? btnTitle : btnEditTitle}
                open={isModalOpen}
                onCancel={handleCancel}
                okButtonProps={{ hidden: "true" }}
                cancelButtonProps={{ hidden: "true" }}
            >
                <GeoForm
                    setIsModalOpen={setIsModalOpen}
                    ostan={ostan}
                    shahrestan={shahrestan}
                    shahr={shahr}
                />
            </Modal>
        </div>
    );
};

export default GeoUnitTable;
